import { Component, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-icon-stack',
  templateUrl: './icon-stack.component.html',
  styleUrls: ['./icon-stack.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class IconStackComponent implements OnInit {
  @HostBinding('class.icon-stack') iconStack = true;
  constructor() { }

  ngOnInit(): void {
  }

}
